module.exports = __webpack_public_path__ + "static/media/website.a860d906.svg";